var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content" },
    [
      _c("order-tree-grid", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.view === "list",
            expression: "view==='list'"
          }
        ],
        ref: "orderTreeGrid",
        attrs: {
          context: _vm.context,
          "use-order-center-mode": _vm.useOrderCenterMode,
          "order-center-branch": _vm.useOrderCenterBranch,
          "approve-cooperation-business": _vm.approveCooperationBusiness
        },
        on: {
          look: _vm.lookHandle,
          add: _vm.addHandle,
          edit: _vm.editHandle,
          copy: _vm.copyHandle
        }
      }),
      _vm.view === "detail"
        ? _c("order-workspace", {
            ref: "orderWorkspace",
            attrs: {
              "parent-context": _vm.context,
              "use-order-center-mode": _vm.useOrderCenterMode,
              "approve-cooperation-business": _vm.approveCooperationBusiness
            },
            on: {
              add: _vm.addHandle,
              edit: _vm.editHandle,
              copy: _vm.copyHandle,
              back: _vm.backToList
            }
          })
        : _vm._e(),
      _c("air-op-type-dialog", {
        attrs: { visible: _vm.airOpTypeDialog.visible },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.airOpTypeDialog, "visible", $event)
          },
          successHandle: _vm.airOpTypeSuccessHandle,
          cancel: _vm.airOpTypeCancelHandle
        }
      }),
      _c("job-copy-window", {
        attrs: {
          visible: _vm.copyDialog.visible,
          lob: _vm.copyDialog.job.lob || ""
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.copyDialog, "visible", $event)
          },
          confirmCallBack: _vm.confirmCallBackHandler
        }
      }),
      _c("job-no-rule-selector", {
        attrs: {
          visible: _vm.jobNoRule.visible,
          rules: _vm.jobNoRule.rules || []
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.jobNoRule, "visible", $event)
          },
          selectedBack: _vm.doCopyJob
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }